export enum SettingModal {
  ConfirmCloseActiveSessions = "ConfirmCloseActiveSessions",
  EnableTfaSms = "EnableTfaSms",
  EnableTfaAuthenticator = "EnableTfaAuthenticator",
  EnableTfaEmail = "EnableTfaEmail",
  DisableTfaSms = "DisableTfaSms",
  DisableTfaAuthenticator = "DisableTfaAuthenticator",
  DisableTfaEmail = "DisableTfaEmail",
  ChangeEmail = "ChangeEmail",
  ChangePassword = "ChangePassword",
}
